export const calculationTypes = {
    GETCAMPAIGNS_SUCCESS: "GETCAMPAIGNS_SUCCESS",
    GETCAMPAIGNS_ERROR: "GETCAMPAIGNS_ERROR",
    TOGGLE_CAMPAIGN_MODAL: "TOGGLE_CAMPAIGN_MODAL",
    GETPAYMENTPLAN_SUCCESS: "GETPAYMENTPLAN_SUCCESS",
    GETPAYMENTPLAN_ERROR: "GETPAYMENTPLAN_ERROR",
    TOGGLE_ADDRESS_MODAL: "TOGGLE_ADDRESS_MODAL",
    SAVEADDRESS_SUCCESS: "SAVEADDRESS_SUCCESS",
    SAVE_PERSONEL_INFO_SUCCESS: "SAVE_PERSONEL_INFO_SUCCESS",
    SET_SELECTED_CAMPAIGN: "SET_SELECTED_CAMPAIGN",
    CUSTOMER_HAS_ADDRESS: "CUSTOMER_HAS_ADDRESS",
    CUSTOMER_HAS_PERSONEL_INFO: "CUSTOMER_HAS_PERSONEL_INFO",
    SAVE_MEMBERSHIP: "SAVE_MEMBERSHIP",
    SAVE_MEMBERSHIP_SUCCESS: "SAVE_MEMBERSHIP_SUCCESS",
    SAVE_MEMBERSHIP_ERROR: "SAVE_MEMBERSHIP_ERROR"
}